//Paquetes NPM de GYF. 
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

//ACTION TYPES
export const ACTUALIZAR_ESTADO_GLOBAL_CLIENT_SEARCH = 'ACTUALIZAR_ESTADO_GLOBAL_CLIENT_SEARCH';
export const GET_SCREEN_DATA_BUSQUEDA_CLIENTE = 'GET_SCREEN_DATA_BUSQUEDA_CLIENTE';
export const ROUTE_TO_VISTA_CLIENTE_BUSQUEDA_CLIENTE = 'ROUTE_TO_VISTA_CLIENTE_BUSQUEDA_CLIENTE';
export const CHANGE_VALUE_SEARCH_BUSQUEDA_CLIENTE = 'CHANGE_VALUE_SEARCH_BUSQUEDA_CLIENTE';
export const RESULT_SEARCH_CLIENT_DDBB_BUSQUEDA_CLIENTE = 'RESULT_SEARCH_CLIENT_DDBB_BUSQUEDA_CLIENTE';
export const RESET_BUSQUEDA_CLIENTE = 'RESET_BUSQUEDA_CLIENTE';
export const RESET_ALL_BUSQUEDA_CLIENTE = 'RESET_ALL_BUSQUEDA_CLIENTE';
export const LOADING_BUSQUEDA_CLIENTE = 'LOADING_BUSQUEDA_CLIENTE';
export const RELOAD = 'RELOAD';
export const RESET_STATE_BUSQUEDA_CLIENTE = 'RESET_STATE_BUSQUEDA_CLIENTE';
export const NOT_FOUND_CLIENTE_BUSQUEDA_CLIENTE = 'NOT_FOUND_CLIENTE_BUSQUEDA_CLIENTE';
export const RELOAD_BUSQUEDA_CLIENTE = 'RELOAD_BUSQUEDA_CLIENTE';
export const RELOAD_BUSQUEDA_CLIENTE_TARJETAS = 'RELOAD_BUSQUEDA_CLIENTE_TARJETAS';
export const CARGAR_CLIENTE_PARA_TARJETA = 'CARGAR_CLIENTE_PARA_TARJETA';
export const NOT_FOUND_CLIENTE_ADICIONAL = 'NOT_FOUND_CLIENTE_ADICIONAL';

let _userFunctions = null;
let me = this;
let _esPersonaFisica = true;
let _documento = undefined;
let _obtenidoDePadron;
let _dispatch = null;

/** 
 * Action que obtiene el estado inicial.
 * @param {any} state
 * @param {any} currentScope
 */
export function getScreenData(state, currentScope) {
    LogHelper.In(getScreenData.name, state, currentScope);
    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({ type: GET_SCREEN_DATA_BUSQUEDA_CLIENTE, state });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => {
            _loadClientSearchFunctions(data);
            LogHelper.Out(getScreenData.name, data);
        }, null, "GETFUNCTIONS", currentScopeRequest);
    }
}

/**
 * 
 * @param {any} id
 * @param {any} clientes
 */
export function obtenerClienteListado(id, clientes) {
    LogHelper.In(obtenerClienteListado.name, id, clientes);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({ type: LOADING_BUSQUEDA_CLIENTE });

        let cliente = clientes.find(x => x.Id == parseInt(id)) == undefined ?
            clientes.find(x => x.unique_id == parseInt(id)) :
            clientes.find(x => x.Id == parseInt(id));

        if (cliente != undefined) {
            _buscarPorDocumentoDatosFiliatorios(cliente.NUMERO_DOCUMENTO);
        }
    }
}

/** 
 * Resetea el state de la pantalla.
 */
export function resetStateBusquedaCliente() {
    LogHelper.In(resetStateBusquedaCliente.name);

    return (dispatch) => {
        _dispatch = dispatch;

        dispatch({
            type: RESET_STATE_BUSQUEDA_CLIENTE
        });
    }
}

/**
 * /Routeo hacia vista de clientes.
 * @param {any} request
 */
export function routeToClientView(request) {
    LogHelper.In(routeToClientView.name, request);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({ type: RESET_ALL_BUSQUEDA_CLIENTE });

        request.esPersonaFisica = _esPersonaFisica;
        if (request.NUMERO_DOCUMENTO.toString().length > 8) {
            switch (request.TIPO_DOCUMENTO) {
                case "CUIL":
                    request.esPersonaFisica = true;
                    break;
                case "CUIT":
                    request.esPersonaFisica = false;
                    break;
            }
        }
        else {
            if (request.TIPO_DOCUMENTO == "CUIT") {
                request.esPersonaFisica = false;
            }
            else {
                request.esPersonaFisica = true;
            }
        }

        let params = JSON.stringify(request);
        dispatch({ type: ROUTE_TO_VISTA_CLIENTE_BUSQUEDA_CLIENTE });
    }
}

/**
 * Búsqueda de cliente por cuit.
 * @param {any} doc
 * @param {any} obtenidoDePadron
 */
export function buscarPorCuit(doc, esAdicional, tipoDoc) {
    return (dispatch, getState) => {
        _dispatch = dispatch;

        let parametroDatosFiliatorios = getParametrosWs(doc, tipoDoc);

        parametroDatosFiliatorios.SOLO_ADICIONAL = esAdicional;

        LogHelper.Out(buscarPorCuit.name, parametroDatosFiliatorios, 'GETCLIENTEDATOSFILIATORIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
        Engine1Proxy.AddRuleRequests(parametroDatosFiliatorios, 'GETCLIENTEDATOSFILIATORIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');

        _dispatch({ type: RELOAD_BUSQUEDA_CLIENTE });
        _dispatch({ type: RELOAD_BUSQUEDA_CLIENTE_TARJETAS, payload:true });

        Engine1Proxy.Execute((data) => _callBackBuscarPorDocumentoDatosFiliatorios(data,parametroDatosFiliatorios,esAdicional), null, null, "CONSULTASOCIOS");         

        //MOCK////////////////////////////////////////////////////////////////////////////////////////////////////////////
        //Validación para consultar los clientes principales y adicionales definidos en los arrays de "cuitClientesPrincipalesMock" y "cuitAdicionalesMock"

        /*
        let paramMock = {
            'CUIT': doc
        }

        Engine1Proxy.AddDataSourcesRequests(paramMock, 'GET_CLIENTE_MOCK', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.Execute((data)=>_callBackBuscarClientesMock(data, doc, esAdicional), null, null, "CONSULTASOCIOS");

        */
    }
}

function _callBackBuscarClientesMock(data, doc, esAdicional) {
    let dataClienteMock = JSON.parse(data.GET_CLIENTE_MOCK).Recordset0.Rows;
    let clienteBDMock = JSON.parse(data.GET_CLIENTE_MOCK).Recordset1.Rows;

    if(dataClienteMock.length == 0) {
        _dispatch({ type: NOT_FOUND_CLIENTE_BUSQUEDA_CLIENTE, errorBusqueda: "No se encontró el cliente mock solicitado." });
        _dispatch({ type: RELOAD_BUSQUEDA_CLIENTE_TARJETAS, payload:false });
    } else {
        let clienteMock = JSON.parse(dataClienteMock[0].DataCliente);

        //clienteMock = getClientesMock(doc);

        if(clienteBDMock.length > 0) {
            clienteMock.Id = clienteBDMock[0].Id;
            clienteMock.resultadoBD = clienteBDMock[0];
            clienteMock.seEncontroEnDB = true;
        }
                
        if(esAdicional) {
            _dispatch({ type: RELOAD_BUSQUEDA_CLIENTE_TARJETAS, payload:false });
            _dispatch({ type: CARGAR_CLIENTE_PARA_TARJETA, payload:clienteMock });
        } else {
            _dispatch({ type: RESET_ALL_BUSQUEDA_CLIENTE });

            _dispatch({
                type: ACTUALIZAR_ESTADO_GLOBAL_CLIENT_SEARCH,
                cliente: clienteMock
            });
            _dispatch({ type: ROUTE_TO_VISTA_CLIENTE_BUSQUEDA_CLIENTE }); 
            
            _dispatch({ type: NOT_FOUND_CLIENTE_ADICIONAL, errorBusqueda: null });
            _dispatch({ type: RELOAD_BUSQUEDA_CLIENTE_TARJETAS, payload:false });
        }
    }
}

/**
 * Búsqueda de clientes por nombre.
 * @param {any} value
 */
export function buscarPorNombre(value) {
    LogHelper.In(buscarPorNombre.name, value);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let parameter = {
            'BUSCAR': value
        }

        LogHelper.Out(buscarPorNombre.name, parameter, 'FULL_TEXT_SEARCH', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(parameter, 'FULL_TEXT_SEARCH', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.Execute(_buscarPorNombre, null, null, "CONSULTASOCIOS");
    }
}

/**
 * Actualización el valor de búsqueda.
 * @param {any} value
 */
export function cambiarBusqueda(value) {
    LogHelper.In(cambiarBusqueda.name, value);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({
            type: CHANGE_VALUE_SEARCH_BUSQUEDA_CLIENTE,
            newSerchValue: value
        });
        if (value.length < 3) {
            dispatch({
                type: RESET_BUSQUEDA_CLIENTE
            });
        }
    }
}

/**
 * Búsqueda de cliente por número de cliente.
 * @param {any} cliente
 */
export function buscarClientePorNroCli(cliente) {
    LogHelper.In(buscarClientePorNroCli.name, cliente);

    return (dispatch, getState) => {
        let parameter = {
            'NRO_CLI': cliente.CliNum
        }

        _dispatch = dispatch;

        LogHelper.Out(buscarClientePorNroCli.name, parameter, 'GET_CLIENTE_NROCLI', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(parameter, 'GET_CLIENTE_NROCLI', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.Execute(_buscarClientePorNroCli, null, cliente.NUMERO_DOCUMENTO, "CONSULTASOCIOS");
    }
}

/** ------------------------------     FUNCIONES AUXILIARES    --------------------------------  **/

/**
 * Búsqueda de cliente por nombre.
 * @param { any } data
 */
function _buscarPorNombre(data) {
    LogHelper.In(_buscarPorNombre.name, data);

    let clientes = JSON.parse(data.FULL_TEXT_SEARCH).Recordset0.Rows;

    if (clientes.length > 0) {
        for (var i = 0; i < clientes.length; i++) {
            clientes[i].NUMERO_DOCUMENTO_FORMATO = GlobalHelper.ConvertirNumeroDocumento(clientes[i].NUMERO_DOCUMENTO, clientes[i].TIPO_DOCUMENTO);
            clientes[i].obtenidoDePadron = true;
        }
    }

    _dispatch({
        type: RESULT_SEARCH_CLIENT_DDBB_BUSQUEDA_CLIENTE,
        resultSearch: clientes
    });
}

/**
 * Búsqueda de cliente por número de client.
 * @param { any } data
 */
function _buscarClientePorNroCli(data) {
    LogHelper.In(_buscarClientePorNroCli.name, data);

    let cliente = JSON.parse(data.GET_CLIENTE_NROCLI).Recordset0.Rows;
    if (cliente.length > 0) {
        _createClient(cliente, true);
    } else {
        let nroDoc = data.CALLER_ID;
        _buscarPorDocumentoDatosFiliatorios(nroDoc);
    }
}

/**
 * Carga de funciones de la pantalla.
 * @param { any } data
 */
function _loadClientSearchFunctions(data) { }

/**
 * Carga de initialState de la pantalla.
 * @param { any } data
 */
function _loadClientViewInitialStateData(data) { }

/**
 * Obtención de cliente por número de documento.
 * @param { any } data
 */
function _getClienteByDocResult(data) {
    LogHelper.In(_getClienteByDocResult.name, data);

    let result = JSON.parse(data.GET_CLIENTE_DOC).Recordset0.Rows;
    let nroDoc = data.CALLER_ID;

    if (result.length > 0) {
        if (_obtenidoDePadron == true) {
            _createClient(result, true);
        } else {
            _createClient(result, false);
        }
    } else {
        _buscarPorDocumentoDatosFiliatorios(nroDoc);
    }
}

/**
 * Creación de cliente.
 * @param { any } clientes
 * @param { any } routeToCV
 */
function _createClient(clientes, routeToCV) {
    LogHelper.In(_createClient.name, clientes, routeToCV);

    let cliente = [];
    for (var i = 0; i < clientes.length; i++) {
        let c = {
            'Id': clientes[i].Id,
            'NOMBRE': clientes[i].Nombre,
            'APELLIDO': clientes[i].Apellido,
            'RAZON_SOCIAL': clientes[i].RazonSocial,
            'CliNum': clientes[i].CliNum,
            'TIPO_DOCUMENTO': clientes[i].TipoDocumentoCodigo,
            'TIPO_DOCUMENTO_ID': clientes[i].TipoDocumentoId,
            'NUMERO_DOCUMENTO': clientes[i].NumeroDocumento,
            'NUMERO_DOCUMENTO_FORMATO': GlobalHelper.ConvertirNumeroDocumento(clientes[i].NumeroDocumento, clientes[i].TipoDocumentoCodigo),
            'rank': 512,
            'unique_id': clientes[i].ClienteBancoNumero,
            'resultadoWS': undefined,
            'resultadoBD': clientes,
            'esPersonaFisica': clientes[i].FisicaJuridica == 'F' ? true : false
        }
        cliente.push(c);
    }

    _dispatch({
        type: ACTUALIZAR_ESTADO_GLOBAL_CLIENT_SEARCH,
        cliente: cliente[0]
    });

    _dispatch({
        type: RESULT_SEARCH_CLIENT_DDBB_BUSQUEDA_CLIENTE,
        resultSearch: cliente
    });

    if (routeToCV && cliente.length === 1) {
        _dispatch({ type: RESET_ALL_BUSQUEDA_CLIENTE });

        cliente[0].esPersonaFisica = _esPersonaFisica;
        let params = JSON.stringify(cliente[0]);
        _dispatch({ type: ROUTE_TO_VISTA_CLIENTE_BUSQUEDA_CLIENTE });
    }
}


/**
 * Call Back que recibe los Datos Filiatorios de cliente a través de la rule
 * @param {any} data
 * @param {any} parametroDatosFiliatorios
 */
function _callBackBuscarPorDocumentoDatosFiliatorios(data, parametroDatosFiliatorios,esAdicional) {
    LogHelper.In(_callBackBuscarPorDocumentoDatosFiliatorios.name, data);

    let clienteDatosFiliatorios = JSON.parse(data.GETCLIENTEDATOSFILIATORIOS);
    
    let parametrosClienteListaDocumentos = parametroDatosFiliatorios;

    LogHelper.Out(buscarPorCuit.name, parametrosClienteListaDocumentos, 'GETCLIENTELISTADOCUMENTOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    Engine1Proxy.AddRuleRequests(parametrosClienteListaDocumentos, 'GETCLIENTELISTADOCUMENTOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');

    Engine1Proxy.Execute((data) => _callBackBuscarClienteListaDocumentos(data, clienteDatosFiliatorios,parametroDatosFiliatorios,esAdicional), null, null, "CONSULTASOCIOS");

}


/**
 * Call Back que recibe los cliente lista de documento por cuit (Productos del cliente) a través de la rule
 * @param {any} data
 */
function _callBackBuscarClienteListaDocumentos(data, clienteDatosFiliatorios,parametroDatosFiliatorios,esAdicional) {
    LogHelper.In(_callBackBuscarClienteListaDocumentos.name, data, clienteDatosFiliatorios,parametroDatosFiliatorios,esAdicional);
    let arregloCuentas=[];
    
    let clienteListaDocumentos = JSON.parse(data.GETCLIENTELISTADOCUMENTOS);

    //EL RESULTADO CON LAS CUENTAS DEL CLIENTE PROVENIENTE DEL WS SE MAPEA Y GUARDA EN UN NUEVO ARREGLO PARA QUE SEA MAS LEGIBLE Y MANIOBRABLE
    //LUEGO SE GUARDA DENTRO DEL OBJETO CLIENTE 
    //SI EXISTE LA PROPIEDAD "DESCRIPTION" LA RULE ENCONTRÓ UN ERROR EN LA RESPUESTA DEL WS O BIEN NO ENCONTRÓ EL CLIENTE
    let hayErrorBusquedaCliente = !(clienteDatosFiliatorios && clienteDatosFiliatorios.DatosClientes && !clienteDatosFiliatorios.Description);
    let hayErrorBusquedaCuentas = !(Array.isArray(clienteListaDocumentos) && clienteListaDocumentos.length > 0) && !esAdicional;
    let hayError =  hayErrorBusquedaCliente || hayErrorBusquedaCuentas;

    if (!hayError) {
        Array.isArray(clienteListaDocumentos) && clienteListaDocumentos.map(cuenta=>{
            if (cuenta.Producto.length > 0) {

                cuenta.Producto.forEach(function (e) {
                    let objAux = {};
                        objAux.TipoFirma = cuenta.Cuenta.TipoFirma;
                        objAux.Sucursal = e.Sucursal,
                        objAux.Estado = e.Estado,
                        objAux.Modulo = e.Modulo,
                        objAux.Moneda = e.Moneda,
                        objAux.SubCuenta = e.SubCuenta,
                        objAux.Sucursal = e.Sucursal,
                        objAux.Id = e.Cuenta,
                        objAux.Descripcion = e.Cuenta,
                        objAux.TipoOperacion = e.TipoOperacion,

                        arregloCuentas.push(objAux)
                }
                )
            }
        });
        
        let documento = parametroDatosFiliatorios.NRO_DOCUMENTO;
        let codigoIva = "0";
        let codigoGanancias = "0";
        let codigoIIBB = "0";
        
        Array.isArray(clienteDatosFiliatorios.ImpuestosCliente) && clienteDatosFiliatorios.ImpuestosCliente.map(impuesto => { 
            if (impuesto.CodImpuesto == "1") { codigoIva = impuesto.CodCondicion } 
            if (impuesto.CodImpuesto == "5") { codigoGanancias = impuesto.CodCondicion } 
            if (impuesto.CodImpuesto == "2") { codigoIIBB = impuesto.CodCondicion } 
        })
        
        clienteDatosFiliatorios.clienteListaDocumentos = arregloCuentas;
        
        let parameter = {
            'NRO_DOC': documento,
            'TIPO_DOCUMENTO_ID':'1'
        }
        let paramIva = {
            'CATEGORIA_IVA_ID': codigoIva
        }
        let paramIvaVisa = {
            'ID': codigoIva
        }
        let paramIIBBVisa = {
            'ID': codigoIIBB
        }
        let paramImpuestos={
            'CATEGORIA_IVA_ID': codigoIva,
            'IIBB_ID':codigoIIBB,
            'GANANCIAS_ID':codigoGanancias
        }

        let paramNomenclatura = {
            'NACIONALIDAD_ID':clienteDatosFiliatorios.DatosClientes.Nacionalidad,
            'OCUPACION_ID': clienteDatosFiliatorios.DatosClientes.TipoPersona !="J" ? clienteDatosFiliatorios.DatosClientes.ActEconomica:"0",
            'ESTADO_CIVIL_ID':clienteDatosFiliatorios.DatosClientes.TipoPersona !="J" ? clienteDatosFiliatorios.DatosClientes.EstadoCivil:"0",
            'MARCA': 'CABAL'
        }

        let paramCabal = {
            'ID': clienteDatosFiliatorios.DatosClientes.TipoDocumentoId,
        }

        let paramDocVisa = {
            'ID': clienteDatosFiliatorios.DatosClientes.TipoDocumentoId,
            'CODIGO_EQUIVALENCIA':'VISA'
        }
        
        

        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, paramIva, 'GET_CATEGORIA_IVA_BY_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramIva, 'GET_CATEGORIA_IVA_BY_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, paramIIBBVisa, 'GET_INGRESOS_BRUTOS_CLIENTE_CATEGORIA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramIIBBVisa, 'GET_INGRESOS_BRUTOS_CLIENTE_CATEGORIA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, paramIvaVisa, 'GET_ATLAS_CATEGORIA_IVA_CODIGO_CLIENTE', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramIvaVisa, 'GET_ATLAS_CATEGORIA_IVA_CODIGO_CLIENTE', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, paramIva, 'GET_CATEGORIA_IVA_CABAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramIva, 'GET_CATEGORIA_IVA_CABAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        
        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, paramImpuestos, 'GET_ATLAS_IMPUESTOS_CLIENTE', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramImpuestos, 'GET_ATLAS_IMPUESTOS_CLIENTE', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, paramCabal, 'GET_CODIGO_DOCUMENTO_CABAL', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramCabal, 'GET_CODIGO_DOCUMENTO_CABAL', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        
        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, paramNomenclatura, 'GET_NOMENCLATURA_CLIENTE_WS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramNomenclatura, 'GET_NOMENCLATURA_CLIENTE_WS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        
        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, paramNomenclatura, 'GET_NOMENCLATURA_CLIENTE_WS_VISA', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramNomenclatura, 'GET_NOMENCLATURA_CLIENTE_WS_VISA', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');

        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, parameter, 'GET_CLIENTE_DOC', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(parameter, 'GET_CLIENTE_DOC', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        
        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, paramCabal, 'GET_ATLAS_TIPO_DOCUMENTO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramCabal, 'GET_ATLAS_TIPO_DOCUMENTO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        
        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, paramNomenclatura, 'GET_OCUPACION_CODIGO_CABAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramNomenclatura, 'GET_OCUPACION_CODIGO_CABAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        
        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, paramNomenclatura, 'GET_ESTADO_CIVIL_CODIGO_CABAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramNomenclatura, 'GET_ESTADO_CIVIL_CODIGO_CABAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        
        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, paramDocVisa, 'GET_EQUIVALENCIA_TIPO_DOCUMENTO_BY_MARCA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramDocVisa, 'GET_EQUIVALENCIA_TIPO_DOCUMENTO_BY_MARCA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        Engine1Proxy.Execute((datos) => _getClienteByDoc(datos, clienteDatosFiliatorios, documento,esAdicional), null, null, "CONSULTASOCIOS");

    } else {
        let mensajeError = "";

        hayErrorBusquedaCliente || hayErrorBusquedaCuentas;

        if (hayErrorBusquedaCliente) {
            if(clienteDatosFiliatorios.Description){
                mensajeError = "[DATOS FILIATORIOS] - " + clienteDatosFiliatorios.Description.toString();
            }else{
                mensajeError = "[DATOS FILIATORIOS] - " + Object.keys(clienteDatosFiliatorios)[0].toString();
            }
        }

        if (hayErrorBusquedaCuentas) {
            if(clienteListaDocumentos.Description){
                mensajeError += (hayErrorBusquedaCliente ? " / " : "") + "[LISTADO CUENTAS] - " + clienteListaDocumentos.Description.toString();
            }else if (typeof clienteListaDocumentos === "string") {
                mensajeError += (hayErrorBusquedaCliente ? " / " : "") + "[LISTADO CUENTAS] - " + clienteListaDocumentos;
            }else {
                mensajeError += (hayErrorBusquedaCliente ? " / " : "") + "[LISTADO CUENTAS] - " + Object.keys(clienteListaDocumentos)[0].toString();
            }
        }
        
        if(!esAdicional){
            _dispatch({ type: NOT_FOUND_CLIENTE_BUSQUEDA_CLIENTE, errorBusqueda: mensajeError });
            _dispatch({ type: RELOAD_BUSQUEDA_CLIENTE_TARJETAS, payload:false });
        }else{
            _dispatch({ type: NOT_FOUND_CLIENTE_ADICIONAL, errorBusqueda: mensajeError });
            _dispatch({ type: RELOAD_BUSQUEDA_CLIENTE_TARJETAS, payload:false });
        }
    }

    
}

//función que recibe la data del WS y de nuestra base de datos para generar el objeto "Cliente" que será utilizado en la app
function _getClienteByDoc(datos, dataWS, documento,esAdicional) {

    let clienteDB = JSON.parse(datos.GET_CLIENTE_DOC).Recordset0.Rows;
    let iva = JSON.parse(datos.GET_CATEGORIA_IVA_BY_ID).Recordset0.Rows;
    let ivaCabal = JSON.parse(datos.GET_CATEGORIA_IVA_CABAL).Recordset0.Rows;
    let ocupacion = JSON.parse(datos.GET_NOMENCLATURA_CLIENTE_WS).Recordset1.Rows;
    let ocupacionVisa = JSON.parse(datos.GET_NOMENCLATURA_CLIENTE_WS_VISA).Recordset1.Rows;
    let estadoCivil = JSON.parse(datos.GET_NOMENCLATURA_CLIENTE_WS).Recordset2.Rows;
    let estadoCivilVisa = JSON.parse(datos.GET_NOMENCLATURA_CLIENTE_WS_VISA).Recordset2.Rows;
    let nacionalidad = JSON.parse(datos.GET_NOMENCLATURA_CLIENTE_WS).Recordset0.Rows;
    let nacionalidadVisa = JSON.parse(datos.GET_NOMENCLATURA_CLIENTE_WS_VISA).Recordset0.Rows;
    let codigoCabalDoc = JSON.parse(datos.GET_CODIGO_DOCUMENTO_CABAL).Recordset0.Rows;
    let estadoCivilCabalDoc = JSON.parse(datos.GET_ESTADO_CIVIL_CODIGO_CABAL).Recordset0.Rows;
    let ocupacionCabalDoc = JSON.parse(datos.GET_OCUPACION_CODIGO_CABAL).Recordset0.Rows;
    let tipoDocumento = JSON.parse(datos.GET_ATLAS_TIPO_DOCUMENTO).Recordset0.Rows;
    let ivaVisa = JSON.parse(datos.GET_ATLAS_CATEGORIA_IVA_CODIGO_CLIENTE).Recordset0.Rows;
    let IIBBVisa = JSON.parse(datos.GET_INGRESOS_BRUTOS_CLIENTE_CATEGORIA).Recordset0.Rows;
    let ingresosBrutos = JSON.parse(datos.GET_ATLAS_IMPUESTOS_CLIENTE).Recordset1.Rows;
    let ganancias = JSON.parse(datos.GET_ATLAS_IMPUESTOS_CLIENTE).Recordset2.Rows;
    let codigoDocVisa = JSON.parse(datos.GET_EQUIVALENCIA_TIPO_DOCUMENTO_BY_MARCA).Recordset0.Rows;
    let clienteWS = dataWS;
    let documentoString = documento.toString();
    let ivaId=null;
    let IIBBId=null;
    let gananciasId=null;
    
    clienteWS.ImpuestosCliente.map(impuesto=>{
        switch (impuesto.CodImpuesto){
            case "1" :{
                ivaId = impuesto.CodCondicion;
                break;
            }
            case "5":{
                gananciasId = impuesto.CodCondicion;
                break;
            }
            case "2":{
                IIBBId = impuesto.CodCondicion;
                break;
            }
        }
    })

    
    clienteDB = clienteDB[0] ? clienteDB[0]:null;
    codigoCabalDoc = codigoCabalDoc[0] ? codigoCabalDoc[0]:null;
    documentoString = clienteWS.DatosClientes.TipoPersona == "F" ? documentoString.substring(2, documentoString.length - 1) : documentoString;

    let domAux = {};
    let telAux = {};
    
    //DOMICILIO Y TELEFONO DEBEN ORGANIZARSE EN EL FORMATO QUE ESTÁ ESPERANDO RECIBIR EL COMPONENTE "EMPRESA"
    if (clienteWS.DomiciliosCliente) {
        domAux = {
            Calle: clienteWS.DomiciliosCliente[0].Calle,
            CodigoPostal: clienteWS.DomiciliosCliente[0].CodPostal,
            Depto: clienteWS.DomiciliosCliente[0].Depto,
            Nivel1: clienteWS.DomiciliosCliente[0].Nivel1,
            Nivel2: clienteWS.DomiciliosCliente[0].Nivel2,
            Numero: clienteWS.DomiciliosCliente[0].Numero,
            Pais: clienteWS.DomiciliosCliente[0].Pais,
            Localidad: clienteWS.DomiciliosCliente[0].Localidad,
            Partido: clienteWS.DomiciliosCliente[0].Partido,
            Piso: clienteWS.DomiciliosCliente[0].Piso,
            Provincia: clienteWS.DomiciliosCliente[0].Provincia,
            CodigoDomicilio: clienteWS.DomiciliosCliente[0].TipoDomicilio,
        }
        domAux.Depto = domAux.Depto ? domAux.Depto.toString().trim().slice(-4) : null ;
    }

    if (clienteWS.TelefonosCliente) {
        telAux = {
            Caracteristica: null,
            Numero: clienteWS.TelefonosCliente.Telefono,
            TipoTel: clienteWS.TelefonosCliente.TipoTel
        }
    }

    let identidadCliente = (clienteWS.DatosClientes.RazonSocial && clienteWS.DatosClientes.RazonSocial != "") ? clienteWS.DatosClientes.RazonSocial : clienteWS.DatosClientes.NombreCompleto + " " + clienteWS.DatosClientes.ApellidoCompleto
    let clienteFinal = {
        APELLIDO: clienteWS.DatosClientes.Apellido1,
        ApellidoCompleto:clienteWS.DatosClientes.ApellidoCompleto,
        NombreCompleto:clienteWS.DatosClientes.NombreCompleto,
        CliNum: clienteWS.CuentaCliente.NroCuenta,
        CuentaCliente: clienteWS.CuentaCliente.NroCuenta,
        Cuit: documento.toString(),
        DatosClientes: clienteWS.DatosClientes,
        Domicilios: [{ Direccion: domAux, Telefono: telAux }],
        DomiciliosCliente: clienteWS.DomiciliosCliente,
        Id: (clienteDB && clienteDB.Id) ? clienteDB.Id : 0,
        LimitePorCuit: null,
        MailsCliente:[clienteWS.MailsCliente],
        NOMBRE: clienteWS.DatosClientes.Nombre1,
        NUMERO_DOCUMENTO: documentoString,
        NUMERO_DOCUMENTO_FORMATO: "",
        RAZON_SOCIAL: clienteWS.DatosClientes.RazonSocial,
        TIPO_DOCUMENTO: (tipoDocumento[0] && tipoDocumento[0].CODIGO) ? tipoDocumento[0].CODIGO : null,
        TIPO_DOCUMENTO_ID: clienteWS.DatosClientes.TipoDocumentoId,
        TelefonosCliente: clienteWS.TelefonosCliente,
        esPersonaFisica: clienteWS.DatosClientes.TipoPersona == "F",
        limiteCompraEmpresaOperativa: null,
        limiteFormato: ",",
        resultadoBD: clienteDB,
        tipoCliente: clienteWS.DatosClientes.TipoPersona == "F" ? "Persona Física" : "Persona Jurídica",
        seEncontroEnDB: (clienteDB && clienteDB.Id) > 0,
        estadoCivilId: clienteWS.DatosClientes.EstadoCivil,
        Nacionalidad: (nacionalidad && nacionalidad[0]) && nacionalidad[0].ID,
        ocupacionId: (ocupacion && ocupacion[0]) && ocupacion[0].ID,  //clienteWS.DatosClientes.ActEconomica,
        iva: iva[0] ? iva[0].Descripcion : "",
        ocupacion: (ocupacion && ocupacion[0]) && ocupacion[0].DESCRIPCION,
        estadoCivil: (estadoCivil && estadoCivil[0]) && estadoCivil[0].DESCRIPCION,
        pais: (nacionalidad && nacionalidad[0]) && nacionalidad[0].DESCRIPCION,
        ClienteListaDocumentos: undefined,
        tipoIva: ivaId,
        ivaCabal:ivaCabal[0]?ivaCabal[0].VALOR_X:null,
        gananciasId:gananciasId,
        gananciasDescripcion:ganancias[0] ? ganancias[0].DESCRIPCION : "",
        IIBBId:IIBBId,
        IIBBDescripcion:ingresosBrutos[0] ? ingresosBrutos[0].DESCRIPCION : "",
        clienteListaDocumentos: clienteWS.clienteListaDocumentos,
        identidadCliente: identidadCliente,
        codigoCabalDoc: codigoCabalDoc ? codigoCabalDoc.VALOR_X : null,
        nacionalidadVisa:nacionalidadVisa[0]?nacionalidadVisa[0].VALOR_X:null,
        ocupacionVisa:ocupacionVisa[0]?ocupacionVisa[0].VALOR_X:null,
        estadoCivilVisa:estadoCivilVisa[0]?estadoCivilVisa[0].VALOR_X:null,
        ivaVisa:ivaVisa[0]?ivaVisa[0].VALOR_X:null,
        IIBBVisa:IIBBVisa[0]?IIBBVisa[0].VALOR_X:null,
        estadoCivilCabalDoc:estadoCivilCabalDoc[0]?estadoCivilCabalDoc[0].VALOR_X:null,
        ocupacionCabalDoc:ocupacionCabalDoc[0]?ocupacionCabalDoc[0].VALOR_X:null,
        documentoCodigoVisa:codigoDocVisa[0]?codigoDocVisa[0].VALOR_X:null
    };
    

    if(iva.length==0){
        _dispatch({ type: NOT_FOUND_CLIENTE_BUSQUEDA_CLIENTE, errorBusqueda: "No se encontró equivalencia para categoría IVA." });
        _dispatch({ type: RELOAD_BUSQUEDA_CLIENTE_TARJETAS, payload:false });
    }else{
        if(esAdicional){
            _dispatch({ type: RELOAD_BUSQUEDA_CLIENTE_TARJETAS, payload:false });
            _dispatch({ type: CARGAR_CLIENTE_PARA_TARJETA, payload:clienteFinal });
        
        }else{
            _dispatch({ type: RESET_ALL_BUSQUEDA_CLIENTE });
        
            _dispatch({
                type: ACTUALIZAR_ESTADO_GLOBAL_CLIENT_SEARCH,
                cliente: clienteFinal
            });
            _dispatch({ type: ROUTE_TO_VISTA_CLIENTE_BUSQUEDA_CLIENTE });
    
            _dispatch({ type: NOT_FOUND_CLIENTE_ADICIONAL, errorBusqueda: null });
            _dispatch({ type: RELOAD_BUSQUEDA_CLIENTE_TARJETAS, payload:false });
        }
    }
}

/**
 * Búsqueda de Limites y Domicilios de cliente por numero de documento
 * @param {any} value
 */
function _buscarPorDocumentoLimitesDomicilios(clienteDatosFiliatorios) {
    LogHelper.In(_buscarPorDocumentoLimitesDomicilios.name, clienteDatosFiliatorios);

    let parametroLimites = {
        'CLIENTE_BANCO_NUMERO': clienteDatosFiliatorios.ClienteBancoNumero,
        'NUMERO_DOCUMENTO': clienteDatosFiliatorios.NumeroDocumento.toString(),
        'TIPO_DOCUMENTO_CODIGO': clienteDatosFiliatorios.TipoDocumento.Codigo,
        'ES_PERSONA_FISICA': clienteDatosFiliatorios.EsPersonaFisica
    }

    let parametroDomicilios = {
        'CLIENTE_BANCO_NUMERO': clienteDatosFiliatorios.ClienteBancoNumero,
        'NUMERO_DOCUMENTO': clienteDatosFiliatorios.NumeroDocumento.toString(),
        'TIPO_DOCUMENTO_CODIGO': clienteDatosFiliatorios.TipoDocumento.Codigo,
        'ES_PERSONA_FISICA': clienteDatosFiliatorios.EsPersonaFisica
    }

    LogHelper.Out(_buscarPorDocumentoLimitesDomicilios.name, parametroLimites, 'GETCLIENTELIMITES', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    Engine1Proxy.AddRuleRequests(parametroLimites, 'GETCLIENTELIMITES', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    LogHelper.Out(_buscarPorDocumentoLimitesDomicilios.name, parametroDomicilios, 'GETCLIENTEDOMICILIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    Engine1Proxy.AddRuleRequests(parametroDomicilios, 'GETCLIENTEDOMICILIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');

    Engine1Proxy.Execute(_callBackBuscarPorDocumentoLimitesDomicilios, null, clienteDatosFiliatorios, "CONSULTASOCIOS");
}

/**
 * Call Back que recibe los Limites y Domicilios de cliente atravez de la rule
 * @param {any} data
 */
function _callBackBuscarPorDocumentoLimitesDomicilios(data) {
    LogHelper.In(_callBackBuscarPorDocumentoLimitesDomicilios.name, data);

    let clienteDatosFiliatorios = data.CALLER_ID;
    let clienteLimite = JSON.parse(data.GETCLIENTELIMITES);
    let clienteDomicilios = JSON.parse(data.GETCLIENTEDOMICILIOS);
    clienteDatosFiliatorios.Limite = clienteLimite.LimiteTotal;
    clienteDatosFiliatorios.LimiteAsignado = clienteLimite.LimiteAsignado;
    clienteDatosFiliatorios.LimitePorCuit = clienteLimite.LimitePorCuit;
    clienteDatosFiliatorios.LimiteSinAsignar = clienteLimite.LimiteSinAsignar;
    clienteDatosFiliatorios.Domicilios = clienteDomicilios;

    _dispatch({ type: RESET_ALL_BUSQUEDA_CLIENTE });
    
    _dispatch({
        type: ACTUALIZAR_ESTADO_GLOBAL_CLIENT_SEARCH,
        cliente: clienteDatosFiliatorios
    });

    _dispatch({ type: ROUTE_TO_VISTA_CLIENTE_BUSQUEDA_CLIENTE });
}

/**
 * Validación de persona física
 * @param {any} estado
 */
function esPersonaFisica(estado) {
    LogHelper.In(esPersonaFisica.name, estado);
    _esPersonaFisica = estado;
    LogHelper.Out(esPersonaFisica.name, _esPersonaFisica);
}

/**
 * Obtiene los parametros del Web Service del Banco
 * @param {any} documento
 */
function getParametrosWs(documento, tipoDoc) {
    LogHelper.In(getParametrosWs.name, documento);

    let valorParseado = parseInt(documento);
    let param = {
        'NRO_DOCUMENTO': valorParseado,
        'PAIS_DOCUMENTO': "80",
        'TIPO_DOCUMENTO': tipoDoc
        }

    return param 
}


function getClientesMock(doc) {
    let clienteMock = {};

    if(doc == "20320887365") {
        clienteMock = 
        {
            "APELLIDO": "BENITEZ",
            "ApellidoCompleto": "BENITEZ",
            "NombreCompleto": "ALBERTO RODRIGO",
            "CliNum": "73692",
            "CuentaCliente": "73692",
            "Cuit": "20320887365",
            "DatosClientes": {
                "Id": 0,
                "TipoDocumentoId": 39,
                "NumeroDocumento": "20320887365",
                "TipoPersona": "F",
                "RazonSocial": "",
                "Apellido1": "BENITEZ",
                "Apellido2": "",
                "Nombre1": "ALBERTO",
                "Nombre2": "RODRIGO",
                "Nombre3": "",
                "Sexo": "M",
                "FechaNac": "19860502",
                "Nacionalidad": "16",
                "EstadoCivil": "3",
                "ActEconomica": "8",
                "SucursalResp": "31",
                "NombreCompleto": "ALBERTO RODRIGO",
                "ApellidoCompleto": "BENITEZ",
                "ClienteBancoSucursal": 100
            },
            "Domicilios": [
                {
                    "Direccion": {
                        "Calle": "B REP ARG MZ 126",
                        "CodigoPostal": "3600",
                        "Depto": "",
                        "Nivel1": "1",
                        "Nivel2": "1",
                        "Numero": "32",
                        "Pais": 16,
                        "Localidad": "FORMOSA",
                        "Partido": 344,
                        "Piso": "0",
                        "Provincia": 10,
                        "CodigoDomicilio": "1"
                    },
                    "Telefono": {
                        "Caracteristica": null,
                        "Numero": "3704507658",
                        "TipoTel": "2"
                    }
                }
            ],
            "DomiciliosCliente": [
                {
                    "TipoDomicilio": "1",
                    "Nivel1": "1",
                    "Calle": "B REP ARG MZ 126",
                    "Nivel2": "1",
                    "Numero": "32",
                    "Piso": "0",
                    "Depto": "",
                    "Pais": 16,
                    "Provincia": 10,
                    "Partido": 344,
                    "Localidad": "FORMOSA",
                    "CodPostal": "3600",
                    "CodigoGeografico": null
                },
                {
                    "TipoDomicilio": "3",
                    "Nivel1": "1",
                    "Calle": "REP. ARG MZ 126 C32",
                    "Nivel2": "1",
                    "Numero": "SIN NRO",
                    "Piso": "",
                    "Depto": "0",
                    "Pais": 16,
                    "Provincia": 10,
                    "Partido": 344,
                    "Localidad": "FORMOSA",
                    "CodPostal": "3600",
                    "CodigoGeografico": null
                },
                {
                    "TipoDomicilio": "10",
                    "Nivel1": "1",
                    "Calle": "",
                    "Nivel2": "1",
                    "Numero": "",
                    "Piso": "",
                    "Depto": "",
                    "Pais": 16,
                    "Provincia": 10,
                    "Partido": 344,
                    "Localidad": "FORMOSA",
                    "CodPostal": "3600",
                    "CodigoGeografico": null
                },
                {
                    "TipoDomicilio": "12",
                    "Nivel1": "1",
                    "Calle": "",
                    "Nivel2": "1",
                    "Numero": "",
                    "Piso": "",
                    "Depto": "",
                    "Pais": 16,
                    "Provincia": 10,
                    "Partido": 344,
                    "Localidad": "FORMOSA",
                    "CodPostal": "3600",
                    "CodigoGeografico": null
                }
            ],
            "Id": 0,
            "LimitePorCuit": null,
            "MailsCliente": [
                {
                    "Mail": "albertorodrigobenitez@gmail.com"
                }
            ],
            "NOMBRE": "ALBERTO",
            "NUMERO_DOCUMENTO": "32088736",
            "NUMERO_DOCUMENTO_FORMATO": "",
            "RAZON_SOCIAL": "",
            "TIPO_DOCUMENTO": "DNI",
            "TIPO_DOCUMENTO_ID": 39,
            "TelefonosCliente": {
                "TipoTel": "2",
                "Telefono": "3704507658"
            },
            "esPersonaFisica": true,
            "limiteCompraEmpresaOperativa": null,
            "limiteFormato": ",",
            "resultadoBD": null,
            //{
            //    "Id": 10,
            //    "ClienteBancoNumero": "73692",
            //    "Apellido": "BENITEZ",
            //    "Nombre": "ALBERTO RODRIGO",
            //    "RazonSocial": null,
            //    "FisicaJuridica": "F",
            //    "TipoDocumentoId": 39,
            //    "NumeroDocumento": 32088736,
            //    "Cuit": 20320887365,
            //    "FechaNacimiento": "1986-05-02T03:00:00",
            //    "CategoriaIvaId": 3,
            //    "TipoIibbId": 3,
            //    "NacionalidadId": 16,
            //    "OcupacionId": 8,
            //    "EstadoCivilId": 3,
            //    "Sexo": "M",
            //    "FechaAlta": "2019-12-16T15:02:31",
            //    "FechaUltimaModificacion": "2023-04-20T12:24:53.353",
            //    "SolicitudId": 3,
            //    "DESCRIPCION": "RESPONSABLE INSCRIPTO"
            //},
            "tipoCliente": "Persona Física",
            "seEncontroEnDB": true,
            "estadoCivilId": "3",
            "Nacionalidad": 16,
            "ocupacionId": 8,
            "iva": "RESPONSABLE INSCRIPTO",
            "ocupacion": "LIC ADM AGRARIA",
            "estadoCivil": "NO INDICADO",
            "pais": "ARGENTINA",
            "tipoIva": "3",
            "ivaCabal": "001",
            "gananciasId": "6",
            "gananciasDescripcion": "INSCR. PERS. FISICA O SUC. IND",
            "IIBBId": "3",
            "IIBBDescripcion": "INSCR. EN OTRA JURISD.",
            "clienteListaDocumentos": [
                {
                    "TipoFirma": "T",
                    "Sucursal": "120",
                    "Estado": "Normal",
                    "Modulo": "21",
                    "Moneda": "80",
                    "SubCuenta": "1",
                    "Id": "73692",
                    "Descripcion": "73692",
                    "TipoOperacion": "3"
                }
            ],
            "identidadCliente": "ALBERTO RODRIGO BENITEZ",
            "codigoCabalDoc": "3",
            "nacionalidadVisa": "AR",
            "ocupacionVisa": "691",
            "estadoCivilVisa": "2",
            "ivaVisa": "I",
            "IIBBVisa": " ",
            "estadoCivilCabalDoc": "C",
            "ocupacionCabalDoc": "841",
            "documentoCodigoVisa": "DNI"
        }
    }

    if(doc == "30585116552") {
        clienteMock =
        {
            "APELLIDO": "",
            "ApellidoCompleto": "",
            "NombreCompleto": "",
            "CliNum": "269341",
            "CuentaCliente": "269341",
            "Cuit": "30585116552",
            "DatosClientes": {
                "Id": 0,
                "TipoDocumentoId": 39,
                "NumeroDocumento": "30585116552",
                "TipoPersona": "J",
                "RazonSocial": "HACIENDAS VILLAGUAY SRL",
                "Apellido1": "",
                "Apellido2": "",
                "Nombre1": "",
                "Nombre2": "",
                "Nombre3": "",
                "Sexo": "",
                "FechaNac": "",
                "Nacionalidad": "16",
                "EstadoCivil": "",
                "ActEconomica": "0",
                "SucursalResp": "100",
                "NombreCompleto": "",
                "ApellidoCompleto": "",
                "ClienteBancoSucursal": 112
            },
            "Domicilios": [
                {
                    "Direccion": {
                        "Calle": "URQUIZA",
                        "CodigoPostal": "3240",
                        "Depto": null,
                        "Nivel1": "1",
                        "Nivel2": "1",
                        "Numero": "454",
                        "Pais": 16,
                        "Localidad": "FORMOSA",
                        "Partido": 344,
                        "Piso": "0",
                        "Provincia": 10,
                        "CodigoDomicilio": "2"
                    },
                    "Telefono": {
                        "Caracteristica": null,
                        "Numero": "03455421050",
                        "TipoTel": "2"
                    }
                }
            ],
            "DomiciliosCliente": [
                {
                    "TipoDomicilio": "2",
                    "Nivel1": "1",
                    "Calle": "URQUIZA",
                    "Nivel2": "1",
                    "Numero": "454",
                    "Piso": "0",
                    "Depto": "",
                    "Pais": 16,
                    "Provincia": 10,
                    "Partido": 344,
                    "Localidad": "FORMOSA",
                    "CodPostal": "3240",
                    "CodigoGeografico": null
                },
                {
                    "TipoDomicilio": "10",
                    "Nivel1": "1",
                    "Calle": "",
                    "Nivel2": "1",
                    "Numero": "",
                    "Piso": "",
                    "Depto": "",
                    "Pais": 16,
                    "Provincia": 9,
                    "Partido": 181,
                    "Localidad": "VILLAGUAY",
                    "CodPostal": "3244",
                    "CodigoGeografico": null
                }
            ],
            "Id": 0,
            "LimitePorCuit": null,
            "MailsCliente": [
                {
                    "Mail": "yonotengo_suegra@hotmail.com"
                }
            ],
            "NOMBRE": "",
            "NUMERO_DOCUMENTO": "30585116552",
            "NUMERO_DOCUMENTO_FORMATO": "",
            "RAZON_SOCIAL": "HACIENDAS VILLAGUAY SRL",
            "TIPO_DOCUMENTO": "DNI",
            "TIPO_DOCUMENTO_ID": 39,
            "TelefonosCliente": {
                "TipoTel": "2",
                "Telefono": "03455421050"
            },
            "esPersonaFisica": false,
            "limiteCompraEmpresaOperativa": null,
            "limiteFormato": ",",
            "resultadoBD": null,
            "tipoCliente": "Persona Jurídica",
            "seEncontroEnDB": false,
            "estadoCivilId": "",
            "Nacionalidad": 16,
            "iva": "RESPONSABLE INSCRIPTO",
            "estadoCivil": "NO INDICADO",
            "pais": "ARGENTINA",
            "tipoIva": "3",
            "ivaCabal": "001",
            "gananciasId": "3",
            "gananciasDescripcion": "NO INSCR. SOC. EMPR. UNIPERS.",
            "IIBBId": "3",
            "IIBBDescripcion": "INSCR. EN OTRA JURISD.",
            "clienteListaDocumentos": [
                {
                    "TipoFirma": "T",
                    "Sucursal": "112",
                    "Estado": "Normal",
                    "Modulo": "20",
                    "Moneda": "80",
                    "SubCuenta": "1",
                    "Id": "269341",
                    "Descripcion": "269341",
                    "TipoOperacion": "2"
                }
            ],
            "identidadCliente": "HACIENDAS VILLAGUAY SRL",
            "codigoCabalDoc": "3",
            "nacionalidadVisa": "AR",
            "ocupacionVisa": null,
            "estadoCivilVisa": null,
            "ivaVisa": "I",
            "IIBBVisa": " ",
            "estadoCivilCabalDoc": null,
            "ocupacionCabalDoc": null,
            "documentoCodigoVisa": "DNI"
        }
    }

    return clienteMock;
}

function getClientesMock_2(doc) {
    let clienteMock = {};
    
    if(doc==11111111111 || doc == "11111111111") {
        clienteMock = {
            APELLIDO: "ZALBAVEASCOBA",
            ApellidoCompleto: "ZALBAVEASCOBA MIRANDA",
            CliNum: "12222",
            ClienteListaDocumentos: undefined,
            CuentaCliente: "12222",
            Cuit: "2023232292",
            DatosClientes:{
                ActEconomica: "999",
                Apellido1: "ZALBAVEASCOBA",
                Apellido2: "",
                ApellidoCompleto: "ZALBAVEASCOBA MIRANDA",
                EstadoCivil: "2",
                FechaNac: "19460810",
                Id: 0,
                Nacionalidad: "80",
                Nombre1: "ROBERTO",
                Nombre2: "SIXTO",
                Nombre3: "",
                NombreCompleto: "ROBERTO SIXTO",
                NumeroDocumento: null,
                RazonSocial: "",
                Sexo: "M",
                SucursalResp: "100",
                TipoDocumentoId: 39,
                TipoPersona: "F",
            },
            Domicilios:[
                {
                    Direccion: {
                    Calle: "B COVIFOL MZ 56",
                    CodigoDomicilio: "1",
                    CodigoPostal: "3600",
                    Depto: "",
                    Localidad: 13611,
                    Nivel1: "1",
                    Nivel2: "1",
                    Numero: "49",
                    Pais: 16,
                    Partido: 344,
                    Piso: "0",
                    Provincia: 10
                    },
                    Telefono:{
                        Caracteristica: null,
                        Numero: "",
                        TipoTel: "0"
                    }
                }
            ],
            DomiciliosCliente: {
                Calle: "B COVIFOL MZ 56",
                CodPostal: "3600",
                CodigoGeografico: 112,
                Depto: "",
                Localidad: 13611,
                Nivel1: "1",
                Nivel2: "1",
                Numero: "49",
                Pais: 16,
                Partido: 344,
                Piso: "0",
                Provincia: 10,
                TipoDomicilio: "1"
            },
            IIBBId: "2",
            Id: 145747,
            LimitePorCuit: 0,
            MailsCliente:[
                {
                    Mail:""
                }
            ],
            NOMBRE: "ROBERTO",
            NUMERO_DOCUMENTO: "2323229",
            NUMERO_DOCUMENTO_FORMATO: undefined,
            Nacionalidad: 16,
            NombreCompleto: "ROBERTO SIXTO",
            RAZON_SOCIAL: "",
            TIPO_DOCUMENTO: "DNI",
            TIPO_DOCUMENTO_ID: 39,
            TelefonosCliente: {
                Telefono: "",
                TipoTel: "0"
            },
            clienteListaDocumentos: [],
            codigoCabalDoc: "3",
            esPersonaFisica: true,
            estadoCivil: "CASADO/A",
            estadoCivilId: "2",
            gananciasId: "4",
            identidadCliente: "ROBERTO SIXTO ZALBAVEASCOBA MIRANDA",
            iva: "RESPONSABLE INSCRIPTO",
            limiteCompraEmpresaOperativa: null,
            limiteFormato: ",",
            ocupacion: "PENSIONADO",
            ocupacionId: 6,
            pais: "ARGENTINA",
            resultadoBD: {
                Apellido: "ZALBAVEASCOBA",
                CategoriaIvaId: 3,
                ClienteBancoNumero: "11787",
                Cuit: 2023232292,
                DESCRIPCION: "RESPONSABLE INSCRIPTO",
                EstadoCivilId: 2,
                FechaAlta: "2019-09-13T18:46:30.173",
                FechaNacimiento: "1946-08-10T04:00:00",
                FechaUltimaModificacion: "2019-09-18T12:34:42.133",
                FisicaJuridica: "F",
                Id: 231233,
                NacionalidadId: 16,
                Nombre: "ROBERTO SIXTO",
                NumeroDocumento: 8229899,
                OcupacionId: 6,
                RazonSocial: null,
                Sexo: "M",
                SolicitudId: 0,
                TipoDocumentoId: 39,
                TipoIibbId: 2
            },
            seEncontroEnDB: true,
            tipoCliente: "Persona Física",
            tipoIibbCodigo: undefined,
            tipoIva: "3"
        }
    }else if(doc==22222222222 || doc == "22222222222") {
         clienteMock = {
            APELLIDO: "RODRÍGUEZ",
            ApellidoCompleto: "RODRÍGUEZ MIRANDA",
            CliNum: "23233",
            ClienteListaDocumentos: undefined,
            CuentaCliente: "23233",
            Cuit: "20555222223",
            DatosClientes:{
                ActEconomica: "999",
                Apellido1: "RODRÍGUEZ",
                Apellido2: "",
                ApellidoCompleto: "RODRÍGUEZ MIRANDA",
                EstadoCivil: "2",
                FechaNac: "19460810",
                Id: 0,
                Nacionalidad: "80",
                Nombre1: "MARCOS",
                Nombre2: "OCTAVIO",
                Nombre3: "",
                NombreCompleto: "MARCOS OCTAVIO",
                NumeroDocumento: null,
                RazonSocial: "",
                Sexo: "M",
                SucursalResp: "100",
                TipoDocumentoId: 39,
                TipoPersona: "F"
            },
            Domicilios:[{
                Direccion:{
                Calle: "B COVIFOL MZ 56",
                CodigoDomicilio: "1",
                CodigoPostal: "3600",
                Depto: "",
                Localidad: 13611,
                Nivel1: "1",
                Nivel2: "1",
                Numero: "49",
                Pais: 16,
                Partido: 344,
                Piso: "0",
                Provincia: 10,
                },
                Telefono:{
                    Caracteristica: null,
                    Numero: "",
                    TipoTel: "0"
                }
            }],
            DomiciliosCliente:{
                Calle: "B COVIFOL MZ 56",
                CodPostal: "3600",
                CodigoGeografico: 112,
                Depto: "",
                Localidad: 13611,
                Nivel1: "1",
                Nivel2: "1",
                Numero: "49",
                Pais: 16,
                Partido: 344,
                Piso: "0",
                Provincia: 10,
                TipoDomicilio: "1"
            },
            IIBBId: "2",
            Id: 145747,
            LimitePorCuit: 0,
            MailsCliente:[{
                Mail:""
            }
            ],
            NOMBRE: "MARCOS",
            NUMERO_DOCUMENTO: "2323229",
            NUMERO_DOCUMENTO_FORMATO: undefined,
            Nacionalidad: 16,
            NombreCompleto: "MARCOS OCTAVIO",
            RAZON_SOCIAL: "",
            TIPO_DOCUMENTO: "DNI",
            TIPO_DOCUMENTO_ID: 39,
            TelefonosCliente:{
                Telefono: "",
                TipoTel: "0"
            },
            clienteListaDocumentos: [],
            codigoCabalDoc: "3",
            esPersonaFisica: true,
            estadoCivil: "CASADO/A",
            estadoCivilId: "2",
            gananciasId: "4",
            identidadCliente: "MARCOS OCTAVIO RODRÍGUEZ MIRANDA",
            iva: "RESPONSABLE INSCRIPTO",
            limiteCompraEmpresaOperativa: null,
            limiteFormato: ",",
            ocupacion: "PENSIONADO",
            ocupacionId: 6,
            pais: "ARGENTINA",
            resultadoBD:{
                Apellido: "RODRÍGUEZ",
                CategoriaIvaId: 3,
                ClienteBancoNumero: "11787",
                Cuit: 20555222223,
                DESCRIPCION: "RESPONSABLE INSCRIPTO",
                EstadoCivilId: 2,
                FechaAlta: "2019-09-13T18:46:30.173",
                FechaNacimiento: "1946-08-10T04:00:00",
                FechaUltimaModificacion: "2019-09-18T12:34:42.133",
                FisicaJuridica: "F",
                Id: 231233,
                NacionalidadId: 16,
                Nombre: "MARCOS OCTAVIO",
                NumeroDocumento: 8229899,
                OcupacionId: 6,
                RazonSocial: null,
                Sexo: "M",
                SolicitudId: 0,
                TipoDocumentoId: 39,
                TipoIibbId: 2
            },
            seEncontroEnDB: true,
            tipoCliente: "Persona Física",
            tipoIibbCodigo: undefined,
            tipoIva: "3"
        }
    }else if(doc==33333333333 || doc == "33333333333"){
         clienteMock = {
                APELLIDO: "LÓPEZ",
                ApellidoCompleto: "LÓPEZ GIMENEZ",
                CliNum: "231211",
                ClienteListaDocumentos: undefined,
                CuentaCliente: "231233",
                Cuit: "20666333223",
                DatosClientes:{
                    ActEconomica: "999",
                    Apellido1: "LÓPEZ",
                    Apellido2: "",
                    ApellidoCompleto: "LÓPEZ GIMENEZ",
                    EstadoCivil: "2",
                    FechaNac: "19460810",
                    Id: 0,
                    Nacionalidad: "80",
                    Nombre1: "ERNESTO",
                    Nombre2: "OCTAVIO",
                    Nombre3: "",
                    NombreCompleto: "ERNESTO OCTAVIO",
                    NumeroDocumento: null,
                    RazonSocial: "",
                    Sexo: "M",
                    SucursalResp: "100",
                    TipoDocumentoId: 39,
                    TipoPersona: "F",
                },
                Domicilios:[{
                    Direccion:{
                    Calle: "B COVIFOL MZ 56",
                    CodigoDomicilio: "1",
                    CodigoPostal: "3600",
                    Depto: "",
                    Localidad: 13611,
                    Nivel1: "1",
                    Nivel2: "1",
                    Numero: "49",
                    Pais: 16,
                    Partido: 344,
                    Piso: "0",
                    Provincia: 10
                    },
                    Telefono:{
                        Caracteristica: null,
                        Numero: "",
                        TipoTel: "0"
                    }
                }],
                DomiciliosCliente:{
                    Calle: "B COVIFOL MZ 56",
                    CodPostal: "3600",
                    CodigoGeografico: 112,
                    Depto: "",
                    Localidad: 13611,
                    Nivel1: "1",
                    Nivel2: "1",
                    Numero: "49",
                    Pais: 16,
                    Partido: 344,
                    Piso: "0",
                    Provincia: 10,
                    TipoDomicilio: "1"
                },
                IIBBId: "2",
                Id: 145747,
                LimitePorCuit: 0,
                MailsCliente:[{
                    Mail:""
                }
                ],
                NOMBRE: "ERNESTO",
                NUMERO_DOCUMENTO: "2323229",
                NUMERO_DOCUMENTO_FORMATO: undefined,
                Nacionalidad: 16,
                NombreCompleto: "ERNESTO OCTAVIO",
                RAZON_SOCIAL: "",
                TIPO_DOCUMENTO: "DNI",
                TIPO_DOCUMENTO_ID: 39,
                TelefonosCliente:{
                    Telefono: "",
                    TipoTel: "0"
                },
                clienteListaDocumentos: [],
                codigoCabalDoc: "3",
                esPersonaFisica: true,
                estadoCivil: "CASADO/A",
                estadoCivilId: "2",
                gananciasId: "4",
                identidadCliente: "ERNESTO OCTAVIO LÓPEZ GIMENEZ",
                iva: "RESPONSABLE INSCRIPTO",
                limiteCompraEmpresaOperativa: null,
                limiteFormato: ",",
                ocupacion: "PENSIONADO",
                ocupacionId: 6,
                pais: "ARGENTINA",
                resultadoBD:{
                    Apellido: "LÓPEZ",
                    CategoriaIvaId: 3,
                    ClienteBancoNumero: "11787",
                    Cuit: 20666333223,
                    DESCRIPCION: "RESPONSABLE INSCRIPTO",
                    EstadoCivilId: 2,
                    FechaAlta: "2019-09-13T18:46:30.173",
                    FechaNacimiento: "1946-08-10T04:00:00",
                    FechaUltimaModificacion: "2019-09-18T12:34:42.133",
                    FisicaJuridica: "F",
                    Id: 231233,
                    NacionalidadId: 16,
                    Nombre: "ERNESTO OCTAVIO",
                    NumeroDocumento: 8229899,
                    OcupacionId: 6,
                    RazonSocial: null,
                    Sexo: "M",
                    SolicitudId: 0,
                    TipoDocumentoId: 39,
                    TipoIibbId: 2
                },
                seEncontroEnDB: true,
                tipoCliente: "Persona Física",
                tipoIibbCodigo: undefined,
                tipoIva: "3"
            }
    }else{
        clienteMock = {
            APELLIDO: "NIELSEN",
            ApellidoCompleto: "NIELSEN RUIZ",
            CliNum: "213123",
            ClienteListaDocumentos: undefined,
            CuentaCliente: "23233",
            Cuit: "20666333213",
            DatosClientes:{
                ActEconomica: "999",
                Apellido1: "NIELSEN",
                Apellido2: "",
                ApellidoCompleto: "NIELSEN RUIZ",
                EstadoCivil: "2",
                FechaNac: "19460810",
                Id: 0,
                Nacionalidad: "80",
                Nombre1: "ERNESTO",
                Nombre2: "OCTAVIO",
                Nombre3: "",
                NombreCompleto: "ERNESTO OCTAVIO",
                NumeroDocumento: null,
                RazonSocial: "",
                Sexo: "M",
                SucursalResp: "100",
                TipoDocumentoId: 39,
                TipoPersona: "F"
            },
            Domicilios:[{
                Direccion:{
                Calle: "B COVIFOL MZ 56",
                CodigoDomicilio: "1",
                CodigoPostal: "3600",
                Depto: "",
                Localidad: 13611,
                Nivel1: "1",
                Nivel2: "1",
                Numero: "49",
                Pais: 16,
                Partido: 344,
                Piso: "0",
                Provincia: 10,
                },
                Telefono:{
                    Caracteristica: null,
                    Numero: "",
                    TipoTel: "0"
                }
            }],
            DomiciliosCliente:{
                Calle: "B COVIFOL MZ 56",
                CodPostal: "3600",
                CodigoGeografico: 112,
                Depto: "",
                Localidad: 13611,
                Nivel1: "1",
                Nivel2: "1",
                Numero: "49",
                Pais: 16,
                Partido: 344,
                Piso: "0",
                Provincia: 10,
                TipoDomicilio: "1"
            },
            IIBBId: "2",
            Id: 145747,
            LimitePorCuit: 0,
            MailsCliente:[{
                Mail:""
            }
            ],
            NOMBRE: "ERNESTO",
            NUMERO_DOCUMENTO: "2323229",
            NUMERO_DOCUMENTO_FORMATO: undefined,
            Nacionalidad: 16,
            NombreCompleto: "ERNESTO OCTAVIO",
            RAZON_SOCIAL: "",
            TIPO_DOCUMENTO: "DNI",
            TIPO_DOCUMENTO_ID: 39,
            TelefonosCliente:{
                Telefono: "",
                TipoTel: "0"
            },
            clienteListaDocumentos: [],
            codigoCabalDoc: "3",
            esPersonaFisica: true,
            estadoCivil: "CASADO/A",
            estadoCivilId: "2",
            gananciasId: "4",
            identidadCliente: "ERNESTO OCTAVIO NIELSEN RUIZ",
            iva: "RESPONSABLE INSCRIPTO",
            limiteCompraEmpresaOperativa: null,
            limiteFormato: ",",
            ocupacion: "PENSIONADO",
            ocupacionId: 6,
            pais: "ARGENTINA",
            resultadoBD:{
                Apellido: "NIELSEN",
                CategoriaIvaId: 3,
                ClienteBancoNumero: "11787",
                Cuit: 20666333213,
                DESCRIPCION: "RESPONSABLE INSCRIPTO",
                EstadoCivilId: 2,
                FechaAlta: "2019-09-13T18:46:30.173",
                FechaNacimiento: "1946-08-10T04:00:00",
                FechaUltimaModificacion: "2019-09-18T12:34:42.133",
                FisicaJuridica: "F",
                Id: 231233,
                NacionalidadId: 16,
                Nombre: "ERNESTO OCTAVIO",
                NumeroDocumento: 8229899,
                OcupacionId: 6,
                RazonSocial: null,
                Sexo: "M",
                SolicitudId: 0,
                TipoDocumentoId: 39,
                TipoIibbId: 2
            },
            seEncontroEnDB: true,
            tipoCliente: "Persona Física",
            tipoIibbCodigo: undefined,
            tipoIva: "3"
        }
    }

    return clienteMock;
}


// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Screens/ClientSearch/actions/Actions.js